import { userErrorMessage } from '@wx-weiqi/contracts';
import { useState } from 'react';
import {
  accountLabel,
  selectedAccount,
  type AiAccountSelectionState,
} from '../stores/ai-account-selection';
import './ai-account-selector.css';

export function AiAccountSelector({
  state,
  onSelect,
  onSaveDefault,
}: {
  readonly state: AiAccountSelectionState;
  readonly onSelect: (id: string) => void;
  readonly onSaveDefault: () => Promise<void>;
}) {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const account = selectedAccount(state);
  const choices = state.aiSelection?.accounts ?? [];
  if (account === null && choices.length === 0) return null;
  const isDefault = state.aiSelectedConfigurationId === state.aiSelection?.defaultConfigurationId;
  return (
    <section className="ai-account-selector" aria-label="算力账号选择">
      <strong>当前使用：{account === null ? '未选择' : accountLabel(account)}</strong>
      {choices.length > 0 ? (
        <div className="ai-account-selector__controls">
          <label>
            本次分析账号
            <select
              aria-label="本次分析账号"
              value={state.aiSelectedConfigurationId ?? ''}
              disabled={saving}
              onChange={(event) => {
                setMessage(null);
                onSelect(event.target.value);
              }}
            >
              {choices.map((item) => (
                <option key={item.configurationId} value={item.configurationId}>
                  {accountLabel(item)}
                </option>
              ))}
            </select>
          </label>
          <button
            type="button"
            disabled={saving || isDefault}
            onClick={() => {
              setSaving(true);
              setMessage(null);
              void onSaveDefault()
                .then(() => setMessage('已保存为我的默认账号。'))
                .catch((error: unknown) =>
                  setMessage(userErrorMessage(error, '保存失败，请刷新后重试。')),
                )
                .finally(() => setSaving(false));
            }}
          >
            {saving ? '保存中…' : isDefault ? '我的默认账号' : '设为我的默认'}
          </button>
        </div>
      ) : null}
      <small>
        {state.aiSelection?.selectionSource === 'LEGACY'
          ? '当前沿用旧平台配置，请在 AI 管理中添加棋院账号并设置默认。'
          : !state.aiSelection?.defaultConfigurationId
            ? '尚未设置个人默认，当前沿用棋院账号。切换仅影响本次使用，不改变学生授权。'
            : '切换仅影响本次使用；设为默认后在其他设备登录也会使用该账号。'}
      </small>
      {message === null ? null : <span role="status">{message}</span>}
    </section>
  );
}
